import {
  Adsterra,
  Assist,
  Dv360,
  Exo,
  Facebook,
  RedTrack,
  Tiktok,
} from './channel';
import { UserDefault, UserSession } from '../user';

import { ApiEvent } from '@src/lib/commonLib/api/client/V1';
import Cookies from 'js-cookie';
import MobileDetect from 'mobile-detect';
import { TopcoStorage } from '../utils';
import _ from 'lodash';

const DELETE_EXPIRE_AT = 'Fri, 17 Jan 2025 00:00:00 GMT'; // 이전날짜 고정

export const enum PARTNER_KEY {
  // 서버에서 pId 캐치시 저장 _gen_token_ga2에 저장시 삭제
  PARTNER_CODE_BEFORE = '_gen_req',
  // 파트너 코드 저장용
  PARTNER_CODE = '_gen_token_ga2',
  // 마케팅 MODE (non_addult === 비성인)
  PARTNER__MODE = '_gen_mode',
  // 웹툰 숏폼 저장용 키
  PARTNER_PROMO = '_gen_token_promo',
  // 파트너 뷰어 방문 확인용
  PARNER_VISITED = '_gen_token_visit',
}

const enum PARTNER_MODE_TYPE {
  NONE = '',
  NON_ADULT = 'na',
  ADULT = 'naxc',
}

interface PartnerItemType {
  pid: string;
  deviceBit: number; // none: 0, pc: 2 mobile : 4 (bit 연산, 0 없음)
  matureBit: number; // 0:비노출 1 비성인 2:성인
  isReferrer: number;
}

const enum DEVICE_BIT {
  PC = 2,
  MOBILE = 4,
}

const enum MATURE_BIT {
  DISABLE = 0,
  NON_ADULT = 1,
  ADULT = 2,
}

const env =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? 'production' : 'staging';
const PartnerListPath = `https://d3juz1fzbt8tvf.cloudfront.net/${env}/partnerCode/partnerCode_en.json`;
// const PartnerListPath = process.env.PARTNER_LiST_JSON_URL ?? '';

const TEST_PARTNER_CODE: string[] = [];
export namespace TopcoPartner {
  /**
   * 쿠키 저장 유효시간 함수
   * @param num
   * @param type
   * @returns
   */
  const getExpireAt = (num: number, type: 'days' | 'hours') => {
    if (type === 'hours') {
      return new Date(
        Date.now() + 60 * 60 * 1000 * num, // {{num}}시간
      ).toUTCString();
    }
    if (type === 'days') {
      return new Date(
        Date.now() + 60 * 60 * 1000 * 24 * num, // {{num}}일
      ).toUTCString();
    }
  };

  /**
   * S3 저장소에서 정적 파일로 리스트 호출
   * @param code
   * @returns
   */
  const getCurrentItemJSON = async (code: string): Promise<PartnerItemType> => {
    try {
      const res = await fetch(PartnerListPath);

      const jsonData = await res.json();
      if (jsonData) {
        const r = _.filter(jsonData, v => v.pid === code);

        if (r.length === 0)
          throw new Error('exception TopcoPartner no matches');

        return r[0];
      } else {
        throw new Error('exception TopcoPartner no jsonData');
      }
    } catch (e) {
      throw new Error('exception TopcoPartner fetch json');
    }
  };

  /**
   * serverside p_id 들어올 시 저장
   * @param context
   * @returns true일 경웅 p_id 제거
   */
  export const setterSSR = async (
    context: any,
    pid?: string,
  ): Promise<boolean> => {
    const { query } = context;

    const {
      p_id,
      subid_short,
      fbclid,
      s2,
      ttclid,
      exotracker,
      assistclickid,
      clickid,
    } = query;

    // p_id 없으면 동작 안함

    const _p_id = p_id || pid;

    if (!_p_id) return false;

    try {
      let ret = false;
      const currentItem = await getCurrentItemJSON(_p_id);
      const { referer } = context.req.headers;

      // url을 직접 입력할 경우 main으로 이동 -> isReferrer 값이 1일 때만
      if (currentItem.isReferrer && !referer) {
        return true;
      }

      const md = new MobileDetect(context.req.headers['user-agent'] ?? '');

      // 모바일
      if (md.tablet() || md.mobile()) {
        ret = checkMobile(currentItem);
      } else {
        // tablet, mobile
        ret = checkPC(currentItem);
      }

      const convert = JSON.stringify(currentItem.pid)
        .unicode()
        .encodeString('test');

      const inDay = new Date(
        Date.now() + 60 * 60 * 24 * 1000 * 1, //1일
      ).toUTCString();

      let mod = PARTNER_MODE_TYPE.NONE;

      // 비성인 파트너코드
      if (currentItem.matureBit & MATURE_BIT.NON_ADULT)
        mod = PARTNER_MODE_TYPE.NON_ADULT;
      else if (currentItem.matureBit & MATURE_BIT.ADULT)
        mod = PARTNER_MODE_TYPE.ADULT;

      const setCookie = [
        `${PARTNER_KEY.PARTNER_CODE_BEFORE}=${convert}; path=/; expires=${inDay}`,
        `${PARTNER_KEY.PARTNER__MODE}=${mod}; path=/; expires=${inDay}`,
      ];

      setCookie.push(
        `${PARTNER_KEY.PARTNER_PROMO}=${p_id}; path=/; expires=${getExpireAt(
          90,
          'days',
        )}`,
      );

      // 페이스북 메타
      if (fbclid) {
        const value = Facebook.getFbcSSR(context, fbclid);
        if (value !== '') {
          setCookie.push(
            `${Facebook.FBC_KEY}=${value}; path=/; expires=${getExpireAt(
              90,
              'days',
            )}`,
          );
        }
      } else {
        setCookie.push(
          `${Facebook.FBC_KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      // adsterra
      if (currentItem.pid.startsWith(Adsterra.PID_START) && subid_short) {
        setCookie.push(
          `${Adsterra.KEY}=${subid_short}; path=/; expires=${getExpireAt(
            7,
            'days',
          )}`,
        );
      } else {
        setCookie.push(
          `${Adsterra.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      // dv360
      if (currentItem.pid.startsWith(Dv360.PID_START) && s2) {
        setCookie.push(
          `${Dv360.KEY}=${s2}; path=/; expires=${getExpireAt(7, 'days')}`,
        );
      } else {
        setCookie.push(
          `${Dv360.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      //tictok
      if (currentItem.pid.startsWith(Tiktok.PID_START) && ttclid) {
        setCookie.push(
          `${Tiktok.KEY}=${ttclid}; path=/; expires=${getExpireAt(7, 'days')}`,
        );
      } else {
        setCookie.push(
          `${Tiktok.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }
      //exo
      if (currentItem.pid.startsWith(Exo.PID_START) && exotracker) {
        setCookie.push(
          `${Exo.KEY}=${exotracker}; path=/; expires=${getExpireAt(7, 'days')}`,
        );
      } else {
        setCookie.push(
          `${Exo.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      //assist
      if (currentItem.pid.startsWith(Assist.PID_START) && assistclickid) {
        setCookie.push(
          `${Assist.KEY}=${assistclickid}; path=/; expires=${getExpireAt(
            7,
            'days',
          )}`,
        );
      } else {
        setCookie.push(
          `${Assist.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      if (clickid) {
        setCookie.push(
          `${RedTrack.KEY}=${clickid}; path=/; expires=${getExpireAt(
            7,
            'days',
          )}`,
        );
      } else {
        setCookie.push(
          `${RedTrack.KEY}=; path=/; domain=global.toptoon.com; expires=${DELETE_EXPIRE_AT};`,
        );
      }

      context.res.setHeader('set-Cookie', setCookie);

      return ret;
    } catch (e) {
      // 오류일 경우 등록되지 않은 파트너 코드로 보고 인덱스로 이동시킴
      console.error(e, 'TopcoPartner setterSSR error');
      return true;
    }
  };

  /**
   * server side props에서 저장된 cookie가 존재할 경우에만 동작
   * @param token
   * @returns
   */
  export const setter = async (token: string): Promise<boolean> => {
    if (!TopcoStorage.isUsed()) return false;

    // 입력된 파트너코드
    const code = Cookies.get(PARTNER_KEY.PARTNER_CODE_BEFORE) || '';
    if (code === '') return false;
    const sendCode = JSON.parse(code.decodeString('test'));

    // 저장되어 있던 파트너코드
    const storedCode = Cookies.get(PARTNER_KEY.PARTNER_CODE) || '';

    saveCookie(code);

    // 입력된 코드와 저장되어 있던 코드가 동일하면 통계 로직 잡히지 않도록 처리
    if (
      storedCode !== '' &&
      sendCode === JSON.parse(storedCode.decodeString('test'))
    )
      return false;

    try {
      const result = await new ApiEvent(
        UserDefault.getUserSession(),
      ).updatePartnerCode({
        partnerCode: sendCode,
      });

      if (_.has(result.data.data, 'mature')) {
        UserSession.setMature(result.data.data.mature);
      }
      return true;
    } catch (e) {
      return false;
    }
  };

  /**
   * 파트너 코드 획득
   * @returns
   */
  export const getter = (): string => {
    if (!TopcoStorage.isUsed()) return '';

    const value = Cookies.get(PARTNER_KEY.PARTNER_CODE) || '';

    if (value === '') return value;

    return JSON.parse(value.decodeString('test'));
  };

  /**
   * 파트너 코드 데이터 획득
   * @returns
   */
  export const getInfo = (): {
    is17: boolean;
    code: string;
  } => {
    const init = {
      is17: false,
      code: '',
    };

    if (!TopcoStorage.isUsed()) return init;

    const pCode = getter();
    if (pCode === '') {
      return init;
    }

    const value = Cookies.get(PARTNER_KEY.PARTNER__MODE) || '';
    init.is17 = value === PARTNER_MODE_TYPE.NON_ADULT; // 비성인 true, 성인 false
    init.code = pCode;

    return init;
  };

  /**
   * cookie 저장시 기존 server side props에서 받은 cookie 제거
   * @param code
   */
  const saveCookie = (code: string) => {
    if (TopcoStorage.isUsed()) {
      const inYear = new Date(
        Date.now() + 60 * 60 * 24 * 1000 * 365, //1년
      );

      Cookies.remove(PARTNER_KEY.PARTNER_CODE_BEFORE);
      Cookies.set(PARTNER_KEY.PARTNER_CODE, code, {
        expires: inYear,
      });
    }
  };

  const checkMobile = (item: PartnerItemType): boolean => {
    if (item.deviceBit & DEVICE_BIT.MOBILE) return true;

    return false;
  };

  const checkPC = (item: PartnerItemType): boolean => {
    if (item.deviceBit & DEVICE_BIT.PC) return true;

    return false;
  };

  // 프롤로그 >연령고지 > 다음화 > 회원가입 > 회원가입 이후 바로 모달창 노출 로직
  export const isTestPartnerCode = () => {
    const pid = getter();
    if (TEST_PARTNER_CODE.includes(pid)) return true;
  };
}
